import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Picture } from 'react-imgix';
import PropTypes from 'prop-types';
const JBResponsiveImage = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = React.Children.toArray(children);
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" className="hidden h-0 w-0" alt="" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <Picture>{t1}{t2}</Picture>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
JBResponsiveImage.propTypes = {
  children: PropTypes.node
};
export default JBResponsiveImage;